/**
 * Clears the stale-asset retry counter once the main bundle runs.
 * Registration of listeners lives in public/index.html so they exist
 * even when a cached index references missing hashed chunks.
 */
try {
  sessionStorage.removeItem("__myparking_asset_retry__");
} catch (e) {
  void e;
}
